/* eslint-disable max-len */
import {React,useState,useEffect} from 'react'
import Emptyscreen from '../../../../components/EmptyScreen';
import { convertEpochToDateFormat } from '../../../../CommonMethods/DateConversion';
import { useSelector } from 'react-redux';
import { BeatLoader } from 'react-spinners';
import CustomOverLay from '../../../../components/CustomOverLay';
import { dataService } from '../../../../services/data.services';

export default function ViewMedicalNoteDetails({patient_id,setNotesCount}) {
    const [items, setItems] = useState([]);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [isLoading, setIsLoading] = useState(true);
    const dateformat=useSelector(state=>state?.systemConfigData?.globalVariables?.date_format)
    const [count, setCount]=useState('')

    useEffect(() => {
        fetchData('initial');
        
    }, []);

    useEffect(() => {
        if (items.length > 0) {
            const initialCollapsedState = items.map((_, index) => index !== 0);
            setCollapsedNotes(initialCollapsedState);
        }
    }, [items]);


    const [collapsedNotes, setCollapsedNotes] = useState(items.map((_, index) => index !== 0));
    const handleCollapseToggle = (index) => {
        setCollapsedNotes(prev => {
            const newCollapsedNotes = [...prev];
            newCollapsedNotes[index] = !newCollapsedNotes[index];
            return newCollapsedNotes;
        });
    };
    useEffect(() => {
        const adjustTextareaHeight = () => {
            const textareas = document.querySelectorAll('.auto-height-textarea');
          
            textareas.forEach((textarea) => {
                textarea.style.height = 'auto';
                textarea.style.height = `${textarea.scrollHeight}px`;
            });
        };
    
        // Call the adjustTextareaHeight function after the initial render
        adjustTextareaHeight();
    
        // Attach the adjustTextareaHeight function to the resize event to handle dynamic content changes
        window.addEventListener('resize', adjustTextareaHeight);
    
        // Clean up the event listener to prevent memory leaks
        return () => {
            window.removeEventListener('resize', adjustTextareaHeight);
        };
    }, [items,collapsedNotes]);

    const user_type_labels = {
        "admin-user": "Admin",
        "super-admin": "Super Admin",
        "corporate-user": "Corporate",
        "organization-user":"Organization User",
        "provider":"Provider",
        "observer":"Observer",
        "monitor-user": "Monitor",
    }

    const fetchData = async(isInitial) => {
        if (!hasMore) return;
        setIsLoading(true);
        try{

            const res = await dataService.PostAPI('',`patients/list-wellness-note?type=medical-note&patient_id=${patient_id}&page_number=${page}&limit=15`)

            setCount(res?.data?.data?.totalCount)
            setNotesCount(res?.data?.data?.totalCount)

            if(res?.data?.data?.totalCount>=0){
                if (res.data?.data?.patientData.length === 0) {
                    setIsLoading(false)
                    setHasMore(false); // No more data available
                }
                
                setItems(prevItems=>[...prevItems,...res?.data?.data?.patientData])
                setPage(prevPage => prevPage + 1);
                setIsLoading(false);
            }
        }catch(error){
            setIsLoading(false);
        }
       
    };

    const handleScroll = () => {
        const scrollArea = document.getElementById('device_scrollarea');
        const { scrollTop, clientHeight, scrollHeight } = scrollArea;
    
        // Adjust for small precision differences due to zoom (use a threshold)
        const scrollThreshold = 10;
    
        if (scrollHeight - scrollTop - clientHeight <= scrollThreshold && !isLoading) {
            fetchData();
        }
    };

    useEffect(() => {
        const adjustTextareaHeight = () => {
            const textareas = document.querySelectorAll('.auto-height-textarea');
          
            textareas.forEach((textarea) => {
                textarea.style.height = 'auto';
                textarea.style.height = `${textarea.scrollHeight}px`;
            });
        };
    
        // Call the adjustTextareaHeight function after the initial render
        adjustTextareaHeight();
    
        // Attach the adjustTextareaHeight function to the resize event to handle dynamic content changes
        window.addEventListener('resize', adjustTextareaHeight);
    
        // Clean up the event listener to prevent memory leaks
        return () => {
            window.removeEventListener('resize', adjustTextareaHeight);
        };
    }, [items,collapsedNotes]);





    return(
        <div id={"device_scrollarea"} className='h-[calc(100vh-361px)] overflow-auto scrollbar_grayw6 px-2.5 pb-2.5 mt-2 rounded-lg mx-[28px]' onScroll={handleScroll}>
            {items.length===0&&isLoading ?            
                <CustomOverLay Active text="Loading Medical Notes..." classKey={`right-20  z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center w-full h-[calc(100vh-375px)]`} /> :
                <>
                    {count>0 &&
                    <div className='flex sticky top-0 left-0 pt-2.5 pb-0.5 bg-white z-30 justify-end'>
                        <button type='button' id='collapse_all' className='text-[16px] text-[#008586] leading-normal font-normal' onClick={() => setCollapsedNotes(new Array(items.length).fill(true))}>
                            <span className='cursor-pointer'>Collapse All</span>
                        </button>
                        <button type='button' id='expand_all' className='pl-[16px] text-[16px] text-[#008586]  leading-normal font-normal' onClick={() => setCollapsedNotes(new Array(items.length).fill(false))}>
                            <span className='cursor-pointer'>Expand All</span>
                        </button>
                    </div>
                    }
                    {items.map((note, index) => (
                        <div key={index}>
                            <div className='bg-[#E5F3F3] w-full items-center py-2 rounded-[4px] mt-[7px] flex px-4 cursor-pointer' onClick={() => handleCollapseToggle(index)}>
                                <p className='text-[18px] text-[#000] font-normal leading-normal'>
                                    {note?.first_name || ''} <span className='pl-1'>{note?.last_name || ''}</span> <span className='pl-1'>
                                        ({user_type_labels[note.user_type] || note.user_type})
                                    </span>
                                </p>
                                <p className='text-[14px] pl-[24px] text-[#52555D] font-normal leading-normal'>{convertEpochToDateFormat(note.created_at,dateformat)}</p>
                                <img className={`ml-auto cursor-pointer rotate ${!collapsedNotes[index] ? "rotate-180" : 'rotate-0'}`} src="/images/collapse.svg" alt="collapse" />
                            </div>
                            {!collapsedNotes[index] && (
                                
                                <textarea
                                    readOnly
                                    value={note.description}
                                    className='text-[16px] py-2 text-[#000000] font-normal w-full outline-0 resize-none auto-height-textarea text-justify'
                                />
                            )}
                        </div>
                    ))}
                </>
            }
            {items.length>0&&isLoading&&<div className="flex justify-center my-3"><BeatLoader color='#972E4C'/></div>}
            {items?.length===0&&!isLoading&& 
                <div className='h-full flex justify-center items-center'> 
                    <Emptyscreen
                        ViewNotes={true}
                        PatientNotes={true}
                        title={"Manage Patients"}
                        FirstPTag={"No Medical notes to view yet."}
                    />
                </div>
            }
            
            
            {/* {medicalNotes.length > 0 ? (
                <>
                    <div className='flex sticky top-0 bg-white pt-5 pb-0.5 left-0 z-30 justify-end'>
                        <button type='button' id='collapse_all' className='text-[16px] text-[#008586] leading-normal font-normal'>
                            <span className='cursor-pointer'  onClick={() => setCollapsedNotes(new Array(medicalNotes.length).fill(true))}>Collapse All</span>
                        </button>
                        <button type='button' id='expand_all' className='pl-[16px] text-[16px] text-[#008586]  leading-normal font-normal'>
                            <span className='cursor-pointer'  onClick={() => setCollapsedNotes(new Array(medicalNotes.length).fill(false))}>Expand All</span>
                        </button>
                    </div>
                    <div>
                        {medicalNotes?.map((note, index) => (
                            <div key={index}>
                                <div className='bg-[#E5F3F3] w-full items-center py-2 rounded-[4px] mt-[7px] flex px-4 cursor-pointer' onClick={() => handleCollapseToggle(index)}>
                                    <p className='text-[18px] text-[#000] font-normal leading-normal'>
                                        {note?.first_name || ''} <span className='pl-1'>{note?.last_name || ''}</span> <span className='pl-1'>
                                            ({user_type_labels[note.user_type] || note.user_type})
                                        </span>
                                    </p>
                                    <p className='text-[14px] pl-[24px] text-[#52555D] font-normal leading-normal'>{convertEpochToDateFormat(note.created_date,dateformat)}</p>
                                    <img className={`ml-auto cursor-pointer rotate ${!collapsedNotes[index] ? "rotate-180" : 'rotate-0'}`} src="/images/collapse.svg" alt="collapse" />
                                </div>
                                {!collapsedNotes[index] && (
                                    <textarea
                                        readOnly
                                        value={note.medical_Notes}
                                        className='text-[16px] py-2 text-[#000000] font-normal w-full outline-0 resize-none auto-height-textarea'
                                    />
                                )}
                            </div>
                        ))}
                    </div>
                </>)
                :
                (
                    <Emptyscreen
                        ViewNotes={true}
                        PatientNotes={true}
                        title={"Manage Patients"}
                        FirstPTag={"No Medical notes to view yet."}
                    />
                )} */}
                    

        </div>
    )
   
}